<template>
  <div v-if="guest">
    <set-icon :guest="guest" @submit="submit" />
    <matching :guest="guest" :scene="scene" @submit="submit" v-if="guest.matching_mode !== 'skip'"/>
  </div>
</template>

<script>
import apiAgent from '../../common/api_agent';
import SetIcon from './_icon'
import Matching from './_matching';

export default {
  components: { SetIcon, Matching },
  props: ['initialGuest', 'scene', 'isSample'],
  data() { return { guest: null } },
  mounted() {
    this.guest = Object.assign({}, this.initialGuest)
  },
  methods: {
    async submit(values) {
      const response = await apiAgent({ url: `${this.isSample ? '/sample' : ''}/guest/current_guest`, method: 'PUT', data: values })
      const json = await response.json()
      this.guest = json.guest
      alert(json.message)
    }
  }
}
</script>

<style scoped>
</style>
